import { noop } from 'lodash';
import PT from 'prop-types';
import React from 'react';

import { useIntl } from 'react-intl';
import Box from '~/ui/components/Box/Box';
import ConfigurationCard from '~/ui/components/ConfigurationCard/ConfigurationCard';

import ConditionRuleInput, {
  conditionRulePropType,
} from './ConditionRuleInput';

const SkipStageAccordion = ({
  conditionRule,
  isSkipped,
  onChange,
  onToggle,
}) => {
  const intl = useIntl();
  return (
    <ConfigurationCard
      isEnabled={isSkipped}
      title={intl.formatMessage({
        id: 'SkipStageAccordion.skipStage',
        defaultMessage: 'Skip Stage',
        description: 'Title for skip stage configuration',
      })}
      onToggleIsEnabled={onToggle}
      onToggleCollapse={noop}
    >
      <Box disabled={!isSkipped}>
        <ConditionRuleInput
          conditionRule={conditionRule}
          label={intl.formatMessage({
            id: 'SkipStageAccordion.skipWhen',
            defaultMessage: 'Skip when',
            description: 'Label for condition rule input',
          })}
          onChange={onChange}
        />
      </Box>
    </ConfigurationCard>
  );
};

SkipStageAccordion.propTypes = {
  /** A ConditionRule interface */
  conditionRule: conditionRulePropType,
  /** If the skip stage is skipped */
  isSkipped: PT.bool.isRequired,
  /** Callback capturing the updated `conditionRule` value */
  onChange: PT.func.isRequired,
  /** Callback capturing toggled isSkipped boolean */
  onToggle: PT.func.isRequired,
};

export default SkipStageAccordion;
